/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Introspektive17Inputs */

const en__field_enum_tuda_introspektive17 = /** @type {(inputs: _Field_Enum_Tuda_Introspektive17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know your own stregths and weakness better`)
};

const de__field_enum_tuda_introspektive17 = /** @type {(inputs: _Field_Enum_Tuda_Introspektive17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persönliche Stärken und Schwächen erkennen`)
};

/**
* | output |
* | --- |
* | "Get to know your own stregths and weakness better" |
*
* @param {_Field_Enum_Tuda_Introspektive17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_introspektive17 = /** @type {((inputs?: _Field_Enum_Tuda_Introspektive17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Introspektive17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_introspektive17(inputs)
	return de__field_enum_tuda_introspektive17(inputs)
});
export { _field_enum_tuda_introspektive17 as "_field_enum_TUDA_INTROSPEKTIVE" }